import { __require as c } from "./index128.js";
var a, u;
function q() {
  if (u) return a;
  u = 1;
  var i = c();
  a = n;
  function n(r, e) {
    return e === void 0 && (e = !0), r && typeof r == "object" ? o(r, e) : Array.isArray(r) ? t(r, e) : i.is(r, e) ? i.parse(r) : r;
  }
  function o(r, e) {
    return Object.keys(r).forEach(function(f) {
      r[f] = n(r[f], e);
    }), r;
  }
  function t(r, e) {
    return r.forEach(function(f, s) {
      r[s] = n(f, e);
    }), r;
  }
  return a;
}
export {
  q as __require
};
//# sourceMappingURL=index113.js.map
